import React from 'react'
// import { CircularProgress } from '@material-ui/core'
// import { useStyles } from './Loader.styles'

export const Loader = () => {
  // const classes = useStyles()

  return <div>{/* <CircularProgress size="10rem" className={classes.loader} /> */}</div>
}
